var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeMutedIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16V6H4.75L11 1V21L4.75 16H1Z",
    fill: "#4B3628",
    stroke: "#AC8D75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8509 6.29439C21.6955 6.06749 21.3607 6.06749 21.2053 6.29439L15.0634 15.2639C14.9721 15.3972 14.9721 15.5728 15.0634 15.706C15.2188 15.9327 15.5534 15.9327 15.7087 15.7059L21.8509 6.73644C21.9421 6.60322 21.9421 6.42762 21.8509 6.29439Z",
    fill: "#AC8D75",
    stroke: "#AC8D75",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4641 6.27008C15.3003 6.05172 14.9728 6.05178 14.8091 6.2702C14.7 6.41574 14.7 6.6158 14.8092 6.76131L21.5359 15.7299C21.6997 15.9483 22.0272 15.9482 22.1909 15.7298C22.3 15.5843 22.3 15.3842 22.1908 15.2387L15.4641 6.27008Z",
    fill: "#AC8D75",
    stroke: "#AC8D75",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMutedIco);
export default __webpack_public_path__ + "static/media/volume-muted_ico.c16da9387a1a4280ce72dadbf9a1b3eb.svg";
export { ForwardRef as ReactComponent };